import { SetMealOutlined } from "@mui/icons-material";
import { Autocomplete, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { useEffect, useState } from "react"
import { Watch } from 'react-loader-spinner'
import { palette } from "../../../assets/theme/theme";


export default function DropdownSelect({
    inputConfiguration,
    onChange,
    value,
    getter,
    formData }: any) {

    const options = inputConfiguration.options;
    const type = inputConfiguration.type;

    const [entityList, setEntityList] = useState<any[]>([]);

    const [loading, setLoading] = useState(false);

    const [mounted, setMounted] = useState(false);


    const [valueToDisplay, setValueToDisplay] = useState(value);


    const getValuesByGetter = async () => {
            setLoading(true);
            const data = await getter();
            setEntityList(data);
            setLoading(false);
    }

    const setDefaultOptions = () => {
        if(options.defaultOptions) {
            setEntityList([...options.defaultOptions])
        } else {
            setEntityList(entityList);
        }
    }

    const hasRegularGetter = () : boolean => {
        return getter && !options.triggerParam;
    }

    const hasInitialTriggerValue = () : boolean => {
        return getter && options.triggerParam && formData[options.triggerParam]
    }

    useEffect(()=> {
        setValueToDisplay(value);
    },[value])


    useEffect(()=> {
        console.log("---------------------> Value to display updated! ", valueToDisplay)
    }, [valueToDisplay])


    useEffect(()=>{
        if (hasRegularGetter() || hasInitialTriggerValue()) {
            getValuesByGetter();
        } else {
            setDefaultOptions();
        }
        setMounted(true);
        
    }, [])


    useEffect(() => {
        if(mounted && getter && options.triggerParam) {
            if (getter && options.triggerParam) {
                getValuesByGetter();
                onChange(null);
            } else {
                setDefaultOptions();
            }
        }
        
    }, [formData[options.triggerParam]])


    const getNestedValue= (option : any, labelKey : string ) => {
        const keys : string[] = labelKey.split('.');
        for (let key of keys) {
            if(!option[key]) return "";
            option = option[key];
        }
        return option;
    }



    return (<>
        {loading ? <Watch
            height="55"
            width="55"
            color={palette.rodrimaq_red}
            ariaLabel='loading'
        /> :

            <FormControl fullWidth>
                {type != 'enum' ?
                    <>
                        <Autocomplete
                            disablePortal
                            id="tags-outlined"
                            options={entityList?.length ? entityList : []}
                            value={value}
                            onChange={(_ , newValue) => { 
                                 onChange(newValue)
                            }}
                            getOptionLabel={(option) => {
                                if(options.labelFunction) {
                                    return options.labelFunction(option)
                                }
                                return getNestedValue(option, options.label)  || "";
                            }}                            
                            renderInput={(params) => <TextField {...params} label={options.name} />}
                        />
                    </> :

                    <>
                        <InputLabel id="input-id">{options.name}</InputLabel>
                            <Select
                                value={valueToDisplay ? valueToDisplay : ""}
                                renderValue={(v) => v}
                                onChange={(_ , newValue: any) => { onChange(newValue.props.value) }}
                                label={options.name}
                                labelId={"input-id"}>
                                {entityList.length ? entityList.map((l, idx) => {
                                    return <MenuItem key={idx} value={l} >{l}</MenuItem>
                                }) : null}
                            </Select>
                        
                    </>}

            </FormControl>

        }


    </>)

}

